module.exports = __webpack_public_path__ + "static/media/nfk.7b51241a.svg";